import { ConfirmInputModal, ActionCard } from "shared/components";
import { EyeClosed } from "iconoir-react";
import { Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useOperatorContext } from "apps/directory/Operator";
import { formatDate, getMultilingualString } from "shared/utils";
import { useBackOffice } from "apps/directory/Operator/views/BackOffice/useBackOffice.ts";
import { useParams } from "react-router-dom";
import { PublicationStatusType } from "gql/generated.ts";

export const UnpublishCard = () => {
  const { t } = useTranslation();
  const { operatorEntityId, organizationId } = useParams();
  const { operator } = useOperatorContext();
  const {
    isUnpublished,
    onUpdatePublicationStatus,
    loadingCreatePublicationStatus,
  } = useBackOffice(operator, operatorEntityId, organizationId);

  const currentStatus =
    operator.status === PublicationStatusType.Unpublished
      ? "REPUBLISH"
      : "UNPUBLISH";

  const [isUnpublishModalOpen, setIsUnpublishModalOpen] = useState(false);

  const handleSetIsModalOpen = () => {
    setIsUnpublishModalOpen(!isUnpublishModalOpen);
  };

  return (
    <>
      <ActionCard
        title={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.TITLE`,
        )}
        subText={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.DESCRIPTION`,
          { date: formatDate(operator.updatedDateISO) },
        )}
        buttonProps={{
          visual: "warning",
          children:
            t(
              `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.BUTTON_TEXT`,
            ) + "...",
          onClick: handleSetIsModalOpen,
        }}
        surfaceProps={{ borderColor: "border.warning" }}
        bodyProps={{ bg: "bg.warning.lightest" }}
        textProps={{ color: "text.warning.dark" }}
      />
      <ConfirmInputModal
        isOpen={isUnpublishModalOpen}
        onClose={handleSetIsModalOpen}
        title={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.TITLE`,
        )}
        HeaderIcon={EyeClosed}
        cancelButtonProps={{
          onClick: handleSetIsModalOpen,
        }}
        saveButtonCopy={t(
          `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.BUTTON_TEXT`,
        )}
        saveButtonProps={{
          visual: currentStatus === "UNPUBLISH" ? "warning" : "success",
          isLoading: loadingCreatePublicationStatus,
          onClick: () =>
            onUpdatePublicationStatus(!isUnpublished, handleSetIsModalOpen),
        }}
        textToConfirm={getMultilingualString(operator.name)}
      >
        <Text color={"text.mid"}>
          {t(
            `directory:OPERATOR.BACK_OFFICE.VISIBILITY_STATUS.PUBLISHING_STATUS.${currentStatus}.MODAL.DESCRIPTION`,
            { date: formatDate(operator.updatedDateISO) },
          )}
        </Text>
      </ConfirmInputModal>
    </>
  );
};
